// Resolver de "entrada no CRM" pela navegação client-centric (navegacao-v2).
// Registrado em crmModule() (@modules/crm/index.js) via
// registerClienteEntranceResolver — a sidebar genérica não conhece nada do CRM,
// só invoca este resolver pela chave do módulo (item.clienteEntranceModule).
//
// Fluxo: consulta crm-cliente-lead-status (id_lead/status_lead REAIS do
// cliente), resolve o mode via resolveClienteTarget (mesma regra usada nas
// rotas de relacionamento/tarefas do CRM) e decide destino + payload do modal
// cliente-360:
//   - mode 'lead'    → navega para crm.leads (aba Leads)
//   - mode 'cliente' → navega para crm.relationship (aba Relacionamento;
//     auto-filtra o cliente ativo via navigation/clientePreFiltro)
import { MODAL } from '@constants/Text'
import { resolveClienteTarget } from '@modules/crm/utils/clienteTarget'
import { apiCrmClienteLeadStatus } from '@modules/crm/api/apiCrmClienteLeadStatus'

const ROUTE_BY_MODE = {
  lead: 'crm.leads',
  cliente: 'crm.relationship',
}

/**
 * @param {Object} ctx
 * @param {Object} ctx.client cliente ativo ($currentClient())
 * @returns {Promise<{routeName: string, modal: {name: string, payload: Object}}>}
 */
export async function resolveCrmClienteEntrance({ client } = {}) {
  const idClienteApp = client && client.id
  const r = await apiCrmClienteLeadStatus.obter({ idClienteApp })
  const leadData = r && r.status === 200 ? r.value || {} : {}
  const target = resolveClienteTarget({
    id_cliente_app: idClienteApp,
    id_lead: leadData.id_lead,
    status_lead: leadData.status_lead,
  })

  return {
    routeName: ROUTE_BY_MODE[target.mode] || ROUTE_BY_MODE.cliente,
    modal: {
      name: MODAL.CRM_LEAD_EDIT,
      payload: {
        item: {
          ...client,
          ...target,
          // O modal (crm-lead-steps.vue) lê item.status para os botões
          // Ganho/Lead/Perda quando mode:'lead' (só aparecem se status for
          // 'em_progresso'/'convertido'/'perda'). É o status DO LEAD — sem
          // sobrescrever aqui, o spread de `...client` acima vaza o status DA
          // CONTA do cliente (ex: 'ativo'), que nunca bate com nenhum desses
          // valores, e os botões somem por completo (bug real observado).
          status: target.status_lead,
        },
      },
    },
  }
}
